/**
 * @desc: 路由映射
 * @created: 2020/5/29
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T4/routeMapping'

export default {
  namespaced: true,
  actions: {
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    getSupplierDetails(ctx, payload) {
      return Models.getSupplierDetails(payload).then(res => {
        return (res && res.status === 200 && res.data) || [{}, {}, {}]
      })
    },

    // 批量映射渠道
    async postBatchRegister(ctx, payload) {
      const res = await Models.postBatchRegister(payload)
      return (res && res.status === 200 && res)
    }
  }
}
